import CategoryServicesGrid from "./CategoryServicesGrid";

export default function ServicesSection({
  categories,
  loading,
  error,
  onCategoryClick,
  onSectionClick,
}) {
  return (
    <section
      id="services"
      className="py-14 md:py-16 min-h-[min(900px,100vh)] flex items-center"
      data-testid="services-section"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-16">
        <div className="text-center max-w-2xl mx-auto mb-8 md:mb-10">
          <div className="font-label text-[#F46524] mb-4">
            Our Services
          </div>

          <h2 className="font-display text-[clamp(2rem,4vw,3.5rem)] tracking-tight leading-tight">
            Tailored for every{" "}
            <span className="text-[#F46524]">occasion</span>.
          </h2>

          <p className="text-[#5b5a56] mt-5">
            Choose a category and explore its sections.
          </p>
        </div>

        <CategoryServicesGrid
          categories={categories}
          loading={loading}
          error={error}
          onCategoryClick={onCategoryClick}
          onSectionClick={onSectionClick}
        />
      </div>
    </section>
  );
}
